import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { TeamParams, TeamResponse } from "@/api/types";

function cleanParams(params: TeamParams): Record<string, string> {
  const clean: Record<string, string> = {};
  if (params.service_id) clean.service_id = params.service_id;
  return clean;
}

export function useBusinessTeam(
  slug: string,
  params: TeamParams = {},
  options: { refetchOnMount?: "always" } = {},
) {
  return useQuery({
    queryKey: ["businesses", slug, "team", params],
    queryFn: () =>
      api
        .get(`businesses/${slug}/team`, { searchParams: cleanParams(params) })
        .json<TeamResponse>(),
    enabled: !!slug,
    staleTime: 5 * 60_000,
    refetchOnMount: options.refetchOnMount,
  });
}
